import { useDisabledFields } from "../../useDisabledFields";
import Popover from "components/Popover";
import {
  Box,
  Checkbox,
  Grid,
  H5,
  Input,
  Stack,
  TextArea
} from "@adfenix/alexandria";
import { useFormContext } from "react-hook-form";
import { ProgramService } from "@adfenix/types";
import InfoCircle from "static/svg/info-circle";
import { useMetaTemplateContext } from "../util/CampaignTemplateContext";
import { useTranslation } from "react-i18next";
import { formMaxWidth } from "../../bundle";

export const ManualReconfiguration = () => {
  const { t } = useTranslation();

  const { campaignTemplate, campaignKey } = useMetaTemplateContext();

  const disabledFields = useDisabledFields();
  const { register } = useFormContext<ProgramService.ProgramModel>();

  return (
    <Stack spacing="l">
      <Box display="flex" flexDirection="row">
        <H5>
          {t("programBuilder.program.template.manualReconfiguration.header")}
        </H5>
        <Popover
          style={{
            display: "flex",
            width: "23px",
            justifyContent: "center",
            marginLeft: "10px"
          }}
          trigger={<InfoCircle />}
        >
          {t("programBuilder.program.template.manualReconfiguration.popover")}
        </Popover>
      </Box>
      <Grid columns={["1fr"]} gap="l" style={{ maxWidth: formMaxWidth }}>
        <Checkbox
          {...register(`${campaignKey}.reconfiguration`)}
          label={t(
            "programBuilder.program.template.manualReconfiguration.checkbox.label"
          )}
          readOnly={disabledFields(
            "bundleGroups.bundles.campaignTemplates.manualCampaignReconfigurationRequired"
          )}
        />
      </Grid>

      {campaignTemplate.reconfiguration && (
        <Grid
          columns={["1fr", "1fr 1fr"]}
          gap="l"
          style={{ maxWidth: formMaxWidth }}
        >
          <Input
            type="number"
            label={t(
              "programBuilder.program.template.manualReconfiguration.delay.label"
            )}
            {...register(`${campaignKey}.reconfigurationDelayInHours`)}
            readOnly={disabledFields(
              "bundleGroups.bundles.campaignTemplates.campaignSchedulingDelayInHours"
            )}
          />
          <div style={{ gridColumn: "span 2" }}>
            <Checkbox
              {...register(
                `${campaignKey}.reconfigurationTargetingFileAllowed`
              )}
              label={t(
                "programBuilder.program.template.manualReconfiguration.reconfigurationTargetingFileAllowed.label"
              )}
              readOnly={disabledFields(
                "bundleGroups.bundles.campaignTemplates.reconfigurationTargetingFileAllowed"
              )}
            />
          </div>

          <div style={{ gridColumn: "span 2" }}>
            <TextArea
              style={{ maxWidth: "100%" }}
              label={t(
                "programBuilder.program.template.manualReconfiguration.comment.label"
              )}
              {...register(`${campaignKey}.reconfigurationInstructions`)}
              readOnly={disabledFields(
                "bundleGroups.bundles.campaignTemplates.campaignReconfigurationHelperComments"
              )}
            />
          </div>
        </Grid>
      )}
    </Stack>
  );
};
